var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "252px",
    height: "157px",
    viewBox: "0 0 252 157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000143931624 0.309132353 209.919236 0.309132353 209.919236 132.587803 0.000143931624 132.587803"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 35.9842206,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 35.9842206,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 35.9842206,
    height: 36
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0.000143931624 0.309132353 209.919236 0.309132353 209.919236 132.587803 0.000143931624 132.587803"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: 0,
    width: 35.9842206,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0,
    y: 0,
    width: 35.9842206,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0,
    y: 0,
    width: 35.9842206,
    height: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-page",
    transform: "translate(-556.000000, -1668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(-725.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1281.000000, 1050.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.000000, 618.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.411456)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.91938,130.189685 C209.91938,131.514126 208.918335,132.587803 207.683402,132.587803 L2.23540205,132.587803 C1.00478667,132.587803 0.000143931624,131.514126 0.000143931624,130.189685 L0.000143931624,2.69889118 C0.000143931624,1.37805294 1.00478667,0.3087 2.23540205,0.3087 L207.683402,0.3087 C208.918335,0.3087 209.91938,1.37805294 209.91938,2.69889118 L209.91938,130.189685 Z",
    id: "Fill-1",
    fill: "#35495D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "6.72160684 118.619632 202.641333 118.619632 202.641333 7.68507353 6.72160684 7.68507353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.275625,127.053109 C111.275625,129.341697 109.424665,131.19505 107.138311,131.19505 C104.852677,131.19505 102.997398,129.341697 102.997398,127.053109 C102.997398,124.764521 104.852677,122.911168 107.138311,122.911168 C109.424665,122.911168 111.275625,124.764521 111.275625,127.053109",
    id: "Fill-19",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(24.210256, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: -29
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-77",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 43.9807141,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "pint",
    transform: "translate(3.998247, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "inner",
    fill: "#F8E71C",
    mask: "url(#mask-4)",
    points: "7.19684413 12.4 28.7873765 12.4 26.3884285 32.8 9.59579217 32.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3857986,0 L29.9868505,36 L5.99737011,36 L3.59842206,0 L32.3857986,0 Z M28.5204221,3.6 L7.46342206,3.6 L9.59754921,32.4 L26.3884285,32.4 L28.5204221,3.6 Z",
    id: "outer",
    fill: "#35495D",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: -20,
    transform: "translate(58.400620, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-78",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 43.9807141,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "gobblet",
    transform: "translate(3.998247, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3857986,14.4 L32.3824627,14.7131369 C32.2332986,21.7079926 27.098608,27.4752257 20.3907855,28.6009455 L20.3910584,32.4 L27.5879025,32.4 L27.5879025,36 L8.39631815,36 L8.39631815,32.4 L15.5931623,32.4 L15.5924368,28.600778 C8.78526687,27.4578915 3.59842206,21.5349376 3.59842206,14.4 L3.59842206,14.4 L3.59842206,0 L32.3857986,0 L32.3857986,14.4 Z M28.7864221,3.599 L7.19642206,3.599 L7.19684413,14.4 C7.19684413,20.3646753 12.0300494,25.2 17.9921103,25.2 C23.9541712,25.2 28.7873765,20.3646753 28.7873765,14.4 L28.7864221,3.599 Z",
    id: "Oval-1",
    fill: "#35495D",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7873765,12.4 L28.7873765,14.8 C28.7873765,20.7646753 23.9541712,25.6 17.9921103,25.6 C12.0300494,25.6 7.19684413,20.7646753 7.19684413,14.8 L7.19684413,14.8 L7.19684413,12.4 L28.7873765,12.4 Z",
    id: "Oval-5",
    fill: "#E43613",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: -25,
    transform: "translate(116.801241, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-79",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 43.9807141,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "glencairn",
    transform: "translate(3.998247, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19684413,12.4 L28.7873765,12.4 L28.7873765,25.6638672 C28.7873765,25.6638672 21.5176151,31.7535156 17.9921103,31.7535156 C14.320771,31.7535156 7.19684413,25.6638672 7.19684413,25.6638672 L7.19684413,12.4 Z",
    id: "Rectangle-15",
    fill: "#D99924",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45287357,15.5844123 C7.28972862,16.3997634 7.21494782,17.1837837 7.2231431,17.9346601 C7.20559237,18.1406752 7.19684413,18.3495102 7.19684413,18.560041 C7.19684413,23.508535 11.1989466,28.7986816 17.9921103,28.7986816 C24.785274,28.7986816 28.7873765,23.508535 28.7873765,18.560041 C28.7873765,18.3495102 28.7786283,18.1406752 28.7614171,17.9337729 C28.7692728,17.1837837 28.694492,16.3997634 28.5313471,15.5844123 C27.7572037,11.7154681 25.7877213,4.7950514 25.5277116,-0.00144519166 C26.7281966,-0.000317277882 27.7568419,0.000982877973 28.3114974,0.00172219303 L28.7501859,0.0023249554 L28.7501859,0.0023249554 C29.2141218,5.64044229 30.9228008,10.8600303 32.027664,16.3818159 C33.2920085,22.7006433 30.5712522,27.606492 25.2794512,30.6235634 C24.9327403,30.8212375 27.423241,35.4967522 27.4095376,36.0008353 L18.0358072,35.9995748 L17.9918072,35.9315748 L17.9478072,35.9995748 L8.57468304,36.0008353 C8.56139345,35.5119762 10.9033315,31.0998463 10.7285663,30.6534882 L10.7047694,30.6235634 C5.41296845,27.606492 2.69221214,22.7006433 3.95655668,16.3818159 C5.06141984,10.8600303 6.80597182,5.64044229 7.26990772,0.0023249554 C7.26990772,0.0023249554 8.62268111,0.000361470199 10.3663894,-0.00138035809 C10.291793,4.74641382 8.25246814,11.5882705 7.45287357,15.5844123 Z",
    id: "Path-4",
    fill: "#35495D",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-21",
    fill: "#3C3C3C",
    mask: "url(#mask-8)",
    points: "8.39631815 0 27.5879025 0 27.5879025 3.6 8.39631815 3.6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(27.210256, 84.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 3.79838148 39.5963636 3.79838148 39.5963636 0.371344444 0 0.371344444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 10.1690111 25.416 10.1690111 25.416 6.73915926 0 6.73915926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FD643F",
    points: "0 18.6570852 10.968 18.6570852 10.968 14.5671593 0 14.5671593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(85.210256, 84.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 3.79838148 39.5963636 3.79838148 39.5963636 0.371344444 0 0.371344444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 10.1690111 25.416 10.1690111 25.416 6.73915926 0 6.73915926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FD643F",
    points: "0 18.6570852 10.968 18.6570852 10.968 14.5671593 0 14.5671593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-5",
    transform: "translate(142.210256, 84.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 3.79838148 39.5963636 3.79838148 39.5963636 0.371344444 0 0.371344444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 10.1690111 25.416 10.1690111 25.416 6.73915926 0 6.73915926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FD643F",
    points: "0 18.6570852 10.968 18.6570852 10.968 14.5671593 0 14.5671593"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(42.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.411456)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.91938,130.189685 C209.91938,131.514126 208.918335,132.587803 207.683402,132.587803 L2.23540205,132.587803 C1.00478667,132.587803 0.000143931624,131.514126 0.000143931624,130.189685 L0.000143931624,2.69889118 C0.000143931624,1.37805294 1.00478667,0.3087 2.23540205,0.3087 L207.683402,0.3087 C208.918335,0.3087 209.91938,1.37805294 209.91938,2.69889118 L209.91938,130.189685 Z",
    id: "Fill-1",
    fill: "#35495D",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "6.72160684 118.619632 202.641333 118.619632 202.641333 7.68507353 6.72160684 7.68507353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.275625,127.053109 C111.275625,129.341697 109.424665,131.19505 107.138311,131.19505 C104.852677,131.19505 102.997398,129.341697 102.997398,127.053109 C102.997398,124.764521 104.852677,122.911168 107.138311,122.911168 C109.424665,122.911168 111.275625,124.764521 111.275625,127.053109",
    id: "Fill-19",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(24.210256, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: -29
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-77",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 43.9807141,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "pint",
    transform: "translate(3.998247, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "inner",
    fill: "#F8E71C",
    mask: "url(#mask-12)",
    points: "7.19684413 12.4 28.7873765 12.4 26.3884285 32.8 9.59579217 32.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3857986,0 L29.9868505,36 L5.99737011,36 L3.59842206,0 L32.3857986,0 Z M28.5204221,3.6 L7.46342206,3.6 L9.59754921,32.4 L26.3884285,32.4 L28.5204221,3.6 Z",
    id: "outer",
    fill: "#35495D",
    mask: "url(#mask-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: -20,
    transform: "translate(58.400620, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-78",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 43.9807141,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "gobblet",
    transform: "translate(3.998247, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3857986,14.4 L32.3824627,14.7131369 C32.2332986,21.7079926 27.098608,27.4752257 20.3907855,28.6009455 L20.3910584,32.4 L27.5879025,32.4 L27.5879025,36 L8.39631815,36 L8.39631815,32.4 L15.5931623,32.4 L15.5924368,28.600778 C8.78526687,27.4578915 3.59842206,21.5349376 3.59842206,14.4 L3.59842206,14.4 L3.59842206,0 L32.3857986,0 L32.3857986,14.4 Z M28.7864221,3.599 L7.19642206,3.599 L7.19684413,14.4 C7.19684413,20.3646753 12.0300494,25.2 17.9921103,25.2 C23.9541712,25.2 28.7873765,20.3646753 28.7873765,14.4 L28.7864221,3.599 Z",
    id: "Oval-1",
    fill: "#35495D",
    mask: "url(#mask-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7873765,12.4 L28.7873765,14.8 C28.7873765,20.7646753 23.9541712,25.6 17.9921103,25.6 C12.0300494,25.6 7.19684413,20.7646753 7.19684413,14.8 L7.19684413,14.8 L7.19684413,12.4 L28.7873765,12.4 Z",
    id: "Oval-5",
    fill: "#E43613",
    mask: "url(#mask-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: -25,
    transform: "translate(116.801241, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-79",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 43.9807141,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "glencairn",
    transform: "translate(3.998247, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-16",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19684413,12.4 L28.7873765,12.4 L28.7873765,25.6638672 C28.7873765,25.6638672 21.5176151,31.7535156 17.9921103,31.7535156 C14.320771,31.7535156 7.19684413,25.6638672 7.19684413,25.6638672 L7.19684413,12.4 Z",
    id: "Rectangle-15",
    fill: "#D99924",
    mask: "url(#mask-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45287357,15.5844123 C7.28972862,16.3997634 7.21494782,17.1837837 7.2231431,17.9346601 C7.20559237,18.1406752 7.19684413,18.3495102 7.19684413,18.560041 C7.19684413,23.508535 11.1989466,28.7986816 17.9921103,28.7986816 C24.785274,28.7986816 28.7873765,23.508535 28.7873765,18.560041 C28.7873765,18.3495102 28.7786283,18.1406752 28.7614171,17.9337729 C28.7692728,17.1837837 28.694492,16.3997634 28.5313471,15.5844123 C27.7572037,11.7154681 25.7877213,4.7950514 25.5277116,-0.00144519166 C26.7281966,-0.000317277882 27.7568419,0.000982877973 28.3114974,0.00172219303 L28.7501859,0.0023249554 L28.7501859,0.0023249554 C29.2141218,5.64044229 30.9228008,10.8600303 32.027664,16.3818159 C33.2920085,22.7006433 30.5712522,27.606492 25.2794512,30.6235634 C24.9327403,30.8212375 27.423241,35.4967522 27.4095376,36.0008353 L18.0358072,35.9995748 L17.9918072,35.9315748 L17.9478072,35.9995748 L8.57468304,36.0008353 C8.56139345,35.5119762 10.9033315,31.0998463 10.7285663,30.6534882 L10.7047694,30.6235634 C5.41296845,27.606492 2.69221214,22.7006433 3.95655668,16.3818159 C5.06141984,10.8600303 6.80597182,5.64044229 7.26990772,0.0023249554 C7.26990772,0.0023249554 8.62268111,0.000361470199 10.3663894,-0.00138035809 C10.291793,4.74641382 8.25246814,11.5882705 7.45287357,15.5844123 Z",
    id: "Path-4",
    fill: "#35495D",
    mask: "url(#mask-16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-21",
    fill: "#3C3C3C",
    mask: "url(#mask-16)",
    points: "8.39631815 0 27.5879025 0 27.5879025 3.6 8.39631815 3.6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(27.210256, 84.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 3.79838148 39.5963636 3.79838148 39.5963636 0.371344444 0 0.371344444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 10.1690111 25.416 10.1690111 25.416 6.73915926 0 6.73915926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FD643F",
    points: "0 18.6570852 10.968 18.6570852 10.968 14.5671593 0 14.5671593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(85.210256, 84.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 3.79838148 39.5963636 3.79838148 39.5963636 0.371344444 0 0.371344444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 10.1690111 25.416 10.1690111 25.416 6.73915926 0 6.73915926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FD643F",
    points: "0 18.6570852 10.968 18.6570852 10.968 14.5671593 0 14.5671593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-5",
    transform: "translate(142.210256, 84.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 3.79838148 39.5963636 3.79838148 39.5963636 0.371344444 0 0.371344444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#35495D",
    opacity: 0.3,
    points: "0 10.1690111 25.416 10.1690111 25.416 6.73915926 0 6.73915926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FD643F",
    points: "0 18.6570852 10.968 18.6570852 10.968 14.5671593 0 14.5671593"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreens);
export default __webpack_public_path__ + "static/media/screens.ffa3f7c8c83f9fe14855b60b9588f229.svg";
export { ForwardRef as ReactComponent };